var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.79,92.25v81.12a17.06,17.06,0,1,1-34.11,0,5.22,5.22,0,0,1,10.43,0,6.63,6.63,0,1,0,13.25,0V92.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.25,102.24c0-44.65,35.58-80.84,79.48-80.84s79.48,36.19,79.48,80.84c0,0-23.75-25.88-52.76,0,0-44.65-12-80.84-26.72-80.84S81,57.59,81,102.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.27,102.24s-23.75-25.88-52.77,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.31,102.24s-23.74-25.88-52.76,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/UMBRELLA.783ad7bd42da8054d2c4c81b9aedcc97.svg";
export { ForwardRef as ReactComponent };